/*       */

import { gql } from '@apollo/client';
import entitiesListRisedCommonQuery from 'graphql/entities/common/entitiesListRisedCommonQuery';

export default gql`
    query printTemplatesListRisedQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        count: count(dataType: "print-template", filterBy: $filterBy, excludeBy: $excludeBy)
        records: printTemplates(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            ${entitiesListRisedCommonQuery}
        }
    }
`;
